import React, { useEffect } from 'react';
import Router from './routes/routers';
import { clearTimeout, setTimeout } from 'worker-timers';
import SoundProvider from './contexts/sound-provider';

function App() {
  // useEffect(() => {
  //   const timer = setTimeout(() => window.location.reload(), 7200000);
  //   return () => clearTimeout(timer);
  // }, []);
  return (
    <div style={{ flex: 1 }}>
      <SoundProvider>
        <Router />
      </SoundProvider>
    </div>
  );
}

export default App;
